export class CustomClaimsDto {
  admin: boolean;
}
